import {HttpClient} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, Routes} from '@angular/router';
import {MsalBroadcastService, MsalService} from '@azure/msal-angular';
import {AuthenticationResult, EventMessage, EventType} from '@azure/msal-browser';
import {filter} from 'rxjs';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.css']
})
export class AuthCallbackComponent implements OnInit  {
  routes: string[] = [];

  constructor(
    private http: HttpClient,
    private authService: MsalService, private route: ActivatedRoute, private router: Router, private msalService: MsalService, private msalBroadcastService: MsalBroadcastService) {}

  getProfile() {
    this.http.get(environment.apiConfig.uri+'/api/test/action1')
      .subscribe(profile => {
        // this.profile = profile;
      });
  }
  getRoutes(routes: Routes, parent: string = ''): string[] {
    let result: string[] = [];

    for (let route of routes) {
      let path = parent + '/' + (route.path || '');

      // Remove leading slash for consistency
      path = path.replace(/\/\//g, '/').replace(/^\//, '');

      result.push(path);

      if (route.children) {
        result = result.concat(this.getRoutes(route.children, path));
      }
    }

    return result;
  }

  ngOnInit(): void {
    this.routes = this.getRoutes(this.router.config);
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
      )
      .subscribe((result: EventMessage) => {
        const payload = result.payload as AuthenticationResult;
        this.authService.instance.setActiveAccount(payload.account);
      });

      // this.authService.instance.getActiveAccount().then(token => {
      //   console.log('Access Token:', token);
      //   // Use the token as needed
      // }).catch(error => {
      //   console.error('Error getting access token', error);
      // });

      // this.authService.acquireTokenSilent(accessTokenRequest).subscribe( (accessTokenReponse) => {
      //   if(accessTokenReponse != null) {
      //     // Acquire token silent success
      //     let accessToken = accessTokenReponse.accessToken;
      //     // Call your API with token
      //     console.log("We got the token! hahaha: " + accessToken);
      //   }

    // this.route.fragment.subscribe((fragment: string | null) => {
    //   if (fragment) {
    //     const params = new URLSearchParams(fragment);
    //     const accessToken = params.get('access_token');

    //     if (accessToken) {
    //       // Store the access token in local storage
    //       localStorage.setItem('access_token', accessToken);

    //       // Optionally, display the token
    //       console.log('Access Token:', accessToken);

    //       // Redirect to the home page or any other page
    //       this.router.navigate(['/']);
    //     } else {
    //       console.error('Access token not found in URL fragment.');
    //     }
    //   }
    // });


  }
}
